/* istanbul ignore file */
import { useIsMobile } from '@mfs/client/listings-client/helpers/useIsMobile'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { Heading, Flex, Box, Divider } from 'pcln-design-system'
import { CheckboxCategoryGroup } from '@pcln/filter'
import { applySetiToFilters } from '../helpers'
import { useAirlinesFilters } from './hooks/useAirlinesFilters'
import { SelectAllorNone } from '../../AllOrNone/SelectAllorNone'

/**
 * Airlines Filters Component Using Hooks
 * @returns <AirlinesFilters />
 */

function AirlinesFilters({ changeHandler }) {
  const isMobile = useIsMobile()
  const isPackageListings = useSelector((state) => state?.pclnBootstrapData?.isPackageListings)
  const showCountInLabel = isPackageListings || !isMobile
  const {
    airlines,
    airlineHandleChange,
    handleOnlyClick,
    resetClick,
    allClick,
    isSelectAllDisabled,
    isSelectNoneDisabled,
  } = useAirlinesFilters({
    changeHandler,
  })

  return (
    // reason to use pb={'24px'} - design system way of using pb={4} doesnot show correct 24px pb. Instead it shows 32px
    <Box pb='24px'>
      <Flex mb={2} alignItems='center' justifyContent='space-between'>
        <Heading fontSize={2} bold>
          Airlines
        </Heading>
      </Flex>
      <Divider mb={2} mt={0} />

      <SelectAllorNone
        isSelectNoneDisabled={isSelectNoneDisabled}
        isSelectAllDisabled={isSelectAllDisabled}
        onSelectAllClick={allClick}
        onSelectNoneClick={resetClick}
      />

      <Box translate='no'>
        <CheckboxCategoryGroup
          filters={applySetiToFilters({
            filters: airlines,
            handleOnlyFilter: handleOnlyClick,
            showCount: showCountInLabel,
          })}
          filterNamePrefix={'airlines'}
          handleChange={airlineHandleChange}
          className='flight-airline-filters'
          wrapLabel={false}
          shouldPadConsistently
        />
      </Box>
    </Box>
  )
}

export default memo(AirlinesFilters)
